var FULL_WIDTH_BUTTONS_BREAKPOINT_PX = 360;
export var buttonShouldFitContainer = function buttonShouldFitContainer(width) {
  return width > 0 && width < FULL_WIDTH_BUTTONS_BREAKPOINT_PX;
};